import { render, staticRenderFns } from "./OpenCasesGrid.vue?vue&type=template&id=9e0ed4c4&scoped=true&"
import script from "./OpenCasesGrid.vue?vue&type=script&lang=js&"
export * from "./OpenCasesGrid.vue?vue&type=script&lang=js&"
import style0 from "./OpenCasesGrid.vue?vue&type=style&index=0&id=9e0ed4c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0ed4c4",
  null
  
)

export default component.exports